export class FooterToolsCtrl {
  constructor(EventService, $scope) {
    'ngInject';
    this.es = EventService;
    this.$scope = $scope;
  }

  $onInit() {
    this.$scope.$watch('$ctrl.activePage', _ => {
      this.activePageStr = this.activePage?.pageNumber?.toString() || '1';
    });
    this.$scope.$watch('$ctrl.pageCount', _ => {
      this.pageNumArray = Array.from({ length: this.pageCount }, (_, i) => i);
    });
  }

  jumpToSelPage() {
    this.es.dispatchEvent(
      this.es.actions.GOTO_PAGE,
      { pageNumber: this.activePageStr });
  }

  setPageZoom() {
    this.es.dispatchEvent(
      this.es.actions.TEMPLATE_ZOOM,
      { zoom: this.pageZoom });
  }
}

export default {
  bindings: {
    pageZoom: '<',
    activePage: '<',
    pageCount: '<'
  },
  controller: FooterToolsCtrl,
  templateUrl: 'form-builder/footer-tools/footer-tools.component.html',
}